import { Environment } from './environment.interface';

export const environment: Environment = {
  production: true,

  client: {
    name: 'aks',
    supportedLanguages: ['de', 'en', 'bs', 'hr', 'hu', 'ro', 'sl', 'bg', 'sr', 'pl', 'el', 'sq'],
    downloadCollectionCategoryIds: [],
  },

  apiData: {
    apiID: 'planonePim',
    apiURL: 'https://backend.docucenter.schueco.com/',
    assetURL: 'https://cdn.docu-center.planone.company/',
  },

  keycloakConfig: {
    url: 'https://login-ext.schueco.com/auth',
    realm: 'schueco',
    clientId: 'schueco-docu',
  },

  basicAuth: 'ZG9jdWNlbnRlcjpkb2N1Y2VudGVy',

  redirect: {
    targetHost: 'techdocweb.alukoenigstahl.com',
  },

  unleash: {
    url: 'https://unleash-proxy.aks.docucenter.schueco.dev/proxy',
    clientKey: '600pCFDQxpht8dDE',
    appName: 'default',
    environment: 'aks-production',
  },
};
